import { composerTextFromHtml } from './composerEditor/headless';
import { stripSignOff } from './templateLint';

const LIST_TAGS = new Set(['UL', 'OL']);

// Drops one trailing piece of nothing (an empty block, a <br>, trailing spaces); false once the end holds words.
function dropTrailingBlank(root: Node): boolean {
  let node: Node | null = root.lastChild;
  while (node) {
    const isBr = node.nodeName === 'BR';
    if (isBr || (node.textContent ?? '').trim() === '') {
      node.parentNode?.removeChild(node);
      return true;
    }
    if (node.nodeType === Node.TEXT_NODE) {
      const trimmed = (node.textContent ?? '').trimEnd();
      if (trimmed === node.textContent) return false;
      node.textContent = trimmed;
      return true;
    }
    node = node.lastChild;
  }
  return false;
}

// One line off the end: the words after the final <br> of the last block (or of a list's last item), else that whole block or item.
function dropLastLine(root: HTMLElement): boolean {
  const last = root.lastElementChild;
  if (!last) return false;
  const block = LIST_TAGS.has(last.tagName) ? last.lastElementChild : last;
  if (!block) {
    last.remove();
    return true;
  }
  const breaks = block.querySelectorAll('br');
  const lastBreak = breaks[breaks.length - 1];
  if (!lastBreak || !block.lastChild) {
    block.remove();
    return true;
  }
  const range = document.createRange();
  range.setStartBefore(lastBreak);
  range.setEndAfter(block.lastChild);
  range.deleteContents();
  return true;
}

/** The step's formatting without its trailing sign-off, or null when the HTML's own text cannot be brought to stripSignOff(body). */
export function stripSignOffHtml(html: string, body: string): string | null {
  const target = stripSignOff(body);
  const root = new DOMParser().parseFromString(html, 'text/html').body;
  let text = composerTextFromHtml(root.innerHTML);
  while (text !== target) {
    if (text.length <= target.length || !dropLastLine(root)) return null;
    while (dropTrailingBlank(root));
    text = composerTextFromHtml(root.innerHTML);
  }
  return root.innerHTML;
}
